import { useTheme as useNextTheme } from "next-themes";

/**
 * 主题管理 Hook（公用）
 *
 * 基于 next-themes 的 useTheme，提供主题切换能力。
 *
 * 功能：
 * - 支持多主题：`light`、`dark`、`system`，以及自定义（如 `theme-dark-blue`）
 * - 自定义主题需在应用层 ThemeProvider 中通过 `themes` 传入，否则无法正确持久化与切回
 * - 自动同步到 localStorage，自动应用主题到 HTML 的 class
 * - 监听系统主题变化（当使用 `system` 时），防止主题闪烁（FOUC）
 *
 * 参考：
 * - https://ui.shadcn.com/docs/theming
 * - https://github.com/pacocoursey/next-themes
 */
export function useTheme() {
  const { theme, setTheme, resolvedTheme, systemTheme } = useNextTheme();

  /**
   * 在 light 与 dark 之间切换（跳过 system）
   */
  const toggleTheme = () => {
    const current = resolvedTheme || "light";
    setTheme(current === "light" ? "dark" : "light");
  };

  return {
    theme,
    resolvedTheme,
    systemTheme,
    setTheme,
    toggleTheme,
  };
}
